import React, { useContext, useEffect, useState } from "react";
import DefaultForm from "../form/index";
import { UserManagementContext } from "../../context/userManagementContext";
import { AppContext } from "../../context/appContext";

type TProps = {
  title: string;
  config: any[]; 
  onSubmit: (val: any) => void;
  prevStep?: () => void; 
  nextStep?: () => void;
}

function StepperForm({title, config, onSubmit, nextStep}: TProps) {
  const { widgetConfig } = useContext(AppContext);
  const {createNewChat, chatIsInitiated, waiting} = useContext(UserManagementContext);

  useEffect(() => {
    chatIsInitiated && nextStep();
  }, [chatIsInitiated])

  const onSubmitWrapper = (data: any) => {
    createNewChat(data);
  }

  return (
    waiting
    ? <div className="hidden">Loading...</div>
    : <>
        <div className="step-title">{title}</div>
        <DefaultForm 
          config={config} 
          onSubmit={onSubmitWrapper}
          ButtonsComponent={() => (
            <div className="flex form-buttons">
              <button className="form-button submit-button" type="submit">
                {widgetConfig.customText.welcomeFormSubmitBtnLabel || "Next"}
              </button>
            </div>
          )}
        />
      </>
  )
}

export default StepperForm;

